import { ActionIcon, Box, Group, Modal, Title, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { IconArrowsDiagonal2 } from '@tabler/icons-react';

import { REPORT_URL } from '@/constant/api.ts';

import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

const reportIframeStyle = {
	border: 'none',
	width: '100%',
	height: '100%',
} as const;

export const Statistics = () => {
	const [opened, { open, close }] = useDisclosure(false);

	return (
		<>
			<LayoutRow
				type="once"
				style={{ height: 'calc(100vh - 116px)', minHeight: 0, overflow: 'hidden' }}
			>
				<Group justify="space-between" align="center" mb={16}>
					<Title size="h4" fw={800}>
						Статистика
					</Title>
					<Tooltip label="Показать в полном экране" withArrow>
						<ActionIcon
							variant="subtle"
							color="gray"
							onClick={open}
							aria-label="Показать в полном экране"
						>
							<IconArrowsDiagonal2 size={20} />
						</ActionIcon>
					</Tooltip>
				</Group>
				<Box
					style={{
						flex: 1,
						minHeight: 0,
						display: 'flex',
						flexDirection: 'column',
						overflow: 'hidden',
					}}
				>
					<iframe src={REPORT_URL} style={reportIframeStyle} />
				</Box>
			</LayoutRow>

			<Modal
				opened={opened}
				onClose={close}
				fullScreen
				title={
					<Title size="h4" fw={800}>
						Статистика
					</Title>
				}
				styles={{
					content: { overflow: 'hidden' },
					body: { height: 'calc(100vh - 60px)', padding: 0 },
				}}
			>
				<iframe src={REPORT_URL} style={reportIframeStyle} />
			</Modal>
		</>
	);
};
